import type { ReportTheme, ReportThemePatch } from '../../types/reportTheme'

async function json<T>(res: Response): Promise<T> {
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(body.error || 'Erreur')
  return body.data as T
}

export async function listThemes(): Promise<ReportTheme[]> {
  const res = await fetch('/api/report-themes', { credentials: 'include' })
  return json<ReportTheme[]>(res)
}

export async function getTheme(id: number): Promise<ReportTheme> {
  const res = await fetch(`/api/report-themes/${id}`, { credentials: 'include' })
  return json<ReportTheme>(res)
}

export async function createTheme(patch: ReportThemePatch = {}): Promise<ReportTheme> {
  const res = await fetch('/api/report-themes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(patch),
  })
  return json<ReportTheme>(res)
}

export async function updateTheme(id: number, patch: ReportThemePatch): Promise<ReportTheme> {
  const res = await fetch(`/api/report-themes/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(patch),
  })
  return json<ReportTheme>(res)
}

export async function deleteTheme(id: number): Promise<void> {
  const res = await fetch(`/api/report-themes/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  })
  await json<null>(res)
}

export async function uploadThemeLogo(file: File): Promise<string> {
  const body = new FormData()
  body.append('file', file)
  const res = await fetch('/api/uploads/theme-images', {
    method: 'POST',
    body,
    credentials: 'include',
  })
  const data = await json<{ url: string }>(res)
  return data.url
}
